import { cn } from '@/lib/utils';
import type { CSSProperties, ReactNode } from 'react';

type NodeSurfaceProps = {
  aspectRatio?: string | number;
  bgStyle?: CSSProperties;
  showDashed?: boolean;
  radiusClass?: string; // e.g., 'rounded-lg' | 'rounded-none'
  insetClass?: string; // e.g., 'inset-0' | 'inset-1'
  className?: string;
  children?: ReactNode;
  onDoubleClick?: () => void;
  overlayTopRight?: ReactNode; // e.g., palette button
};

export function NodeSurface({
  aspectRatio,
  bgStyle,
  showDashed = true,
  radiusClass = 'rounded-lg',
  insetClass = 'inset-0',
  className,
  children,
  onDoubleClick,
  overlayTopRight,
}: NodeSurfaceProps) {
  return (
    <div
      className={cn('relative w-full', radiusClass, className)}
      style={aspectRatio ? { aspectRatio: String(aspectRatio) } : undefined}
      onDoubleClick={onDoubleClick}
    >
      <div className={cn('absolute transition-[inset] duration-200 ease-out', insetClass, radiusClass)} style={bgStyle} />
      {showDashed && (
        <div className={cn('pointer-events-none absolute border-2 border-dashed border-border transition-[inset] duration-200 ease-out', insetClass, radiusClass)} />
      )}
      {overlayTopRight ? (
        <div className="absolute top-2 right-2 z-10">{overlayTopRight}</div>
      ) : null}
      <div className={cn('absolute overflow-hidden transition-[inset] duration-200 ease-out', insetClass, radiusClass)}>
        {children}
      </div>
    </div>
  );
}


